import { evalAmount, isExpression } from '../../lib/eval-amount'

interface Props {
  value: string
  onChange: (v: string) => void
}

export default function AmountInput({ value, onChange }: Props) {
  const showExpr = isExpression(value)
  const result = showExpr ? evalAmount(value) : null

  function handleChange(raw: string) {
    // 只允許數字、+ - * / . 空白括號
    onChange(raw.replace(/[^\d+\-*/.() ]/g, ''))
  }

  return (
    <div className="field">
      <label htmlFor="amount">金額（NT$）</label>
      <input
        id="amount"
        inputMode="text"
        placeholder="0　或　200+150+300"
        value={value}
        onChange={e => handleChange(e.target.value)}
        className="amount-input"
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
      />
      {showExpr && (
        <p className={`amount-preview${result == null ? ' invalid' : ''}`}>
          {result != null ? `= NT$${result.toLocaleString()}` : '運算式無效'}
        </p>
      )}
    </div>
  )
}
